import React, { useState, useEffect } from "react";
import { environment } from "../../environment";
import axios from "axios";
import { Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import NavbarNew from "../Components/NavbarNew";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const CustomersForAdmin = ({ history }) => {
  const [customers, setCustomers] = useState([]);
  const [email, setEmail] = useState("");
  const [customerCount, setCustomerCount] = useState("");
  var customers_array = [];
  useEffect(() => {
    axios
      .post(environment.dap_url + "crm_api/getAllCustomer", {
        filters: { userType: "CUSTOMER_USER", isDeleted: false },
      })
      .then((res) => {
        console.log(res.data);
        setCustomers(res.data);
        console.log(res.data.length);
        setCustomerCount(res.data.length);
        customers_array = res.data;
        console.log(customers_array);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const viewAnserHandler = (id) => {
    console.log(id);
    history.push(`/viewResponse/${id}`);
  };
  //console.log(id);
  const columns = [
    {
      dataField: "id",
      text: "#",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
    },
    {
      dataField: "createdAt",
      text: "Created On",
      sort: true,
      formatter: (dataField) => {
        let dateArr = dataField.split("T")[0].split("-");
        return dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
      },
    },
    {
      dataField: "userFirstName",
      text: "Name",
      sort: true,
      formatter: (row, cell, rowIndex, formatExtraData) => {
        console.log(cell.userFirstName);
        if (cell.userFirstName) {
          return cell.userFirstName + " " + cell.userLastName;
        } else {
          return "";
        }
      },
    },
    // {
    //   dataField: "isLead",
    //   text: "status",
    //   sort: true,
    //   formatter:(dataField)=>{
    //     if(dataField){
    //       return <Button variant="primary" className="btn btn-sm">Lead</Button>
    //     }else{
    //       return <Button variant="success" className="btn btn-sm">Customer</Button>
    //     }
    //   }
    // },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      formatter: (cell, row) => {
        const isActive = row.isActive;
        const isDeleted = row.isDeleted;
        const color = isActive && !isDeleted ? "" : "red";

        return <span style={{ color }}>{cell}</span>;
      },
    },
    // {
    //   dataField: "phone",
    //   text: "Phone",
    //   sort: true,
    // },
    {
      dataField: "parentId",
      text: "Partner",
      sort: true,
      formatter: (_, row, rowIndex, formatExtraData) => {
        if (row.partner_details.length > 0) {
          return (
            row.partner_details[0].userFirstName +
            " " +
            row.partner_details[0].userLastName
          );
        }
        return "";
      },
    },

    {
      dataField: "address",
      text: "Address",
      sort: true,
    },
    {
      dataField: "_id",
      text: "Action",
      sort: false,
      formatter: (dataField) => {
        return (
          <div>
            <button className="btn btn-light">
              <Link to={`/customers/view/` + dataField}>
                <i className="mdi mdi-eye-outline text-primary"></i>View
              </Link>
            </button>
          </div>
        );
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];

  return (
    <>
      <div className="container-fluid">
        <NavbarNew />
        <h4 className="card-title">CUSTOMERS</h4>
        <div className="row">
          <div className="col-12">
            <ToolkitProvider
              keyField="id"
              bootstrap4
              data={customers}
              columns={columns}
              search
            >
              {(props) => (
                <div>
                  <div className="d-flex align-items-center">
                    <p className="mb-2 mr-2">Search in table:</p>
                    <SearchBar {...props.searchProps} />
                  </div>
                  <BootstrapTable
                    defaultSorted={defaultSorted}
                    pagination={paginationFactory()}
                    {...props.baseProps}
                    wrapperClasses="table-responsive"
                  />
                </div>
              )}
            </ToolkitProvider>
          </div>
        </div>
      </div>

      {/* <h5 style={{ marginLeft: "5%" }}>
        Total Number of Entries: {customerCount}
      </h5> */}
    </>
  );
};

export default CustomersForAdmin;
